var map = {
	"./detail1.png": "cb17",
	"./detail2.png": "9cb5",
	"./detail3.png": "6b94",
	"./detail4.png": "1c48",
	"./detail5.png": "1020",
	"./img1.png": "41fa",
	"./img2.png": "c92e",
	"./img3.png": "4cfd",
	"./img4.png": "3019",
	"./img5.png": "498f",
	"./img_solution1.png": "43e7",
	"./img_solution2.png": "dc2f",
	"./img_solution3.png": "0516",
	"./img_solution4.png": "7226",
	"./img_solution5.png": "cc36",
	"./solution1.png": "2f3a",
	"./solution2.png": "2fca",
	"./solution3.png": "9dda",
	"./solution4.png": "0c98",
	"./solution5.png": "1509"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a72a";